"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const load_role_stats_multi_1 = __importDefault(require("@app/ac/load-role-stats-multi"));
const moment_1 = __importDefault(require("moment"));
const request_1 = require("../request");
const store_1 = __importDefault(require("../store"));
const add_error_1 = __importDefault(require("./add-error"));
const is_loading_1 = __importDefault(require("./is-loading"));
const util_1 = require("@app/util");
const create_ac_1 = require("./util/create-ac");
// import { setAvailabilities, setTimeOffs } from '@app/action'
const setAvailabilityOrTimeOff = (0, create_ac_1.createAC)(async (dispatch, { evts, unavId }) => {
    const { auth, workspaceId, calendar } = store_1.default.getState();
    if (!workspaceId ||
        !evts?.length ||
        evts.some((e) => !e.period?.start || !e.period?.end || !e.user))
        return;
    const isCreatingNew = !unavId;
    const availOrTimeOff = util_1.calendarUtil.isEventAvailabilityOrTimeOff(evts[0]);
    if (evts.some((e) => util_1.calendarUtil.isEventAvailabilityOrTimeOff(e) !== availOrTimeOff))
        return;
    // prepare the input data
    const data = [];
    evts.forEach((evt) => {
        const { period, periodType, user, available, categoryId, contractId, note, recurrence, workMinutesBy, workMinutes, workMinutesInclusion, attachments, recurrenceUpdateFollowing, } = evt;
        data.push(availOrTimeOff === 'timeOff'
            ? {
                // input data for TimeOff
                id: unavId || undefined,
                user,
                period,
                periodType,
                categoryId,
                contractId,
                workMinutesBy,
                workMinutes,
                note,
                recurrence,
                attachments,
                workMinutesInclusion: isCreatingNew &&
                    (0, moment_1.default)(period?.end).diff(period?.start, 'minutes') >
                        1440 /* 'workMinutesInclusion' makes sense only for multi-day timeoffs */
                    ? workMinutesInclusion
                    : undefined,
                recurrenceUpdateFollowing: isCreatingNew
                    ? undefined
                    : recurrenceUpdateFollowing,
            }
            : {
                // input data for availability / unavailability
                id: unavId || undefined,
                user,
                period,
                available: Boolean(available),
                note,
                recurrence,
                recurrenceUpdateFollowing: isCreatingNew
                    ? undefined
                    : recurrenceUpdateFollowing,
            });
        if (availOrTimeOff !== 'timeOff') {
            // @ts-expect-error
            delete data[data.length - 1].categoryId;
        }
        if (data[data.length - 1].recurrence) {
            const newRecurrence = { ...data[data.length - 1].recurrence };
            delete newRecurrence.id;
            // @ts-expect-error
            data[data.length - 1].recurrence = recurrenceUpdateFollowing
                ? newRecurrence
                : undefined;
        }
    });
    void dispatch((0, is_loading_1.default)('set-availability-or-time-off'));
    let result = null;
    if (!isCreatingNew) {
        // if 'unavId' is set, we're modifying the existing event
        const requestVars = {
            workspace: workspaceId,
            data: data.map((d) => Object.assign({ id: unavId }, d)),
        };
        if (availOrTimeOff === 'timeOff') {
            result = await (0, request_1.requestTimeOffUpdateMulti)(requestVars, auth);
            /*
            NOTE: No need to update the store here. This is done by WebSockets
            const updatedTimeoffs = [...timeOffs]
            const timeoffIndex = updatedTimeoffs.findIndex((item) => item.id === unavId)
            updatedTimeoffs[timeoffIndex] = {
              ...updatedTimeoffs[timeoffIndex],
              ...data
            }
            dispatch(setTimeOffs(updatedTimeoffs))
            */
        }
        else {
            result = await (0, request_1.requestAvailabilityUpdateMulti)(requestVars, auth);
            /*
            NOTE: No need to update the store here. This is done by WebSockets
            const updatedAvailabilities = [...availabilities]
            const availIndex = updatedAvailabilities.findIndex((item) => item.id === unavId)
            updatedAvailabilities[availIndex] = {
              ...updatedAvailabilities[availIndex],
              ...data
            }
            dispatch(setAvailabilities(updatedAvailabilities))
            */
        }
    }
    else {
        // otherwise, we're just creating a new event
        const requestVars = {
            workspace: workspaceId,
            data,
        };
        result =
            availOrTimeOff === 'timeOff'
                ? await (0, request_1.requestTimeOffCreateMulti)(requestVars, auth)
                : await (0, request_1.requestAvailabilityCreateMulti)(requestVars, auth);
    }
    // @ts-expect-error
    if (!result || result.error) {
        // @ts-expect-error
        if (result)
            void dispatch((0, add_error_1.default)(result.error));
    }
    // if we added/created a timeOff, and we have the store.calendar loaded,
    // reload the role stats (because the new timeOff might change the values there)
    if (result &&
        // @ts-expect-error
        !result.error &&
        availOrTimeOff === 'timeOff' &&
        calendar &&
        calendar.date) {
        void dispatch((0, load_role_stats_multi_1.default)(calendar.date));
    }
    void dispatch((0, is_loading_1.default)('set-availability-or-time-off', true));
    return result;
});
exports.default = setAvailabilityOrTimeOff;
